<template>
  <v-btn
    @click="openCreativePage"
    color="primary"
    class="d-inline-flex"
    small
    flat
  >
    <v-icon small>open_in_new</v-icon>
    <span style="padding-left: 5px">クリエイティブ追加</span>
  </v-btn>
</template>

<script>
export default {
  name: 'CampaignModalPageCreativeOpenCreativePage',
  methods: {
    openCreativePage() {
      const { agencyId, advertiserId } = this.$route.params
      const url = `/agencies/${agencyId}/advertisers/${advertiserId}/creatives`
      window.open(url)
    },
  },
}
</script>
